"use client";

import { fetchAuthSession } from "aws-amplify/auth";
import {
  getCommonAPIHeaders,
  getCookieValue,
  getProjectSpecificData,
  isWhatuni,
} from "../utlils/commonFunction";
import eventEmitter, {
  CustomEvents,
} from "@packages/lib/eventEmitter/eventEmitter";
import * as CryptoJS from "crypto-js";
import API_URL from "@packages/lib/server-actions/api-urls";
import { setDocumentCookie } from "./cookie-utils";

const PGS_USER_ID_ENCRYPTION_KEY = "whatuni12345@#&!";

const getUserFavourites = async (): Promise<any> => {
  try {
    const payload: any = {
      affiliateId: getProjectSpecificData("affiliateId"),
    };
    const headers: any = {
      ...getCommonAPIHeaders(),
      sitecode: process.env.SITE_CODE,
    };
    let apiUrl = `${process.env.NEXT_PUBLIC_BFF_API_DOMAIN}${API_URL?.getUserFavourites}`;
    if (isWhatuni()) {
      const session: any = await fetchAuthSession({ forceRefresh: true });
      headers.Authorization = `${session.tokens.idToken}`;
    } else {
      if (!getCookieValue("pgs_userid")) throw new Error("Unauthorized user");
      apiUrl =
        process.env.NEXT_PUBLIC_BFF_API_DOMAIN + API_URL?.getGuestFavourites;
      const encrypteduserid = encrypt(
        PGS_USER_ID_ENCRYPTION_KEY,
        getCookieValue("pgs_userid")
      );
      headers.encrypteduserid = `${encrypteduserid}`;
    }
    const respone = await fetch(apiUrl, {
      method: "POST",
      headers,
      body: payload ? JSON.stringify(payload) : undefined,
      cache: "no-store",
    });
    const data = await respone.json();
    return data;
  } catch (error) {
    console.log("error", error);
  }
};

async function addRemoveFavourites(payload: any[]) {
  try {
    const favpayload = {
      affiliateId: getProjectSpecificData("affiliateId"),
      AddFavoriteRequestList: payload,
    };
    const session = await fetchAuthSession();
    const headers: any = {
      ...getCommonAPIHeaders(),
      sitecode: process.env.SITE_CODE,
    };
    let apiUrl =
      process.env.NEXT_PUBLIC_BFF_API_DOMAIN + API_URL?.addRemoveUserFavourites;
    if (isWhatuni() && session.tokens?.idToken) {
      headers.Authorization = `${session.tokens.idToken}`;
    } else if (getCookieValue("pgs_userid")) {
      apiUrl =
        process.env.NEXT_PUBLIC_BFF_API_DOMAIN +
        API_URL?.addRemoveGuestFavourites;
      const encrypteduserid = encrypt(
        PGS_USER_ID_ENCRYPTION_KEY,
        getCookieValue("pgs_userid")
      );
      headers.encrypteduserid = `${encrypteduserid}`;
    }
    const respone = await fetch(apiUrl, {
      method: "POST",
      headers,
      body: payload ? JSON.stringify(favpayload) : undefined,
      cache: "no-store",
    });
    const data = await respone.json();
    if (data?.status === 200) {
      setDocumentCookie({ name: "basketId", value: data?.basketId });
      const newFavourite = data?.count;
      if (isWhatuni()) {
        setDocumentCookie({
          name: "USER_FAV_BASKET_COUNT",
          value: newFavourite,
          options: { maxAge: 60 * 60 * 24 },
        });
      } else {
        setDocumentCookie({ name: "pgs_bskt_cnt", value: newFavourite });
      }
      eventEmitter.emit(CustomEvents.FavouriteCookieUpdated, newFavourite);
    } else if (data?.status === 500 || data?.status === 401) {
      throw new Error("Error while favouriting: Internal server error");
    }
    return data;
  } catch (error) {
    console.log("error", error);
    throw error;
  }
}

function encrypt(keys: string, value: any) {
  const key = CryptoJS.enc.Utf8.parse(keys);
  const iv = CryptoJS.enc.Utf8.parse(keys);
  const encrypted = CryptoJS.AES.encrypt(
    CryptoJS.enc.Utf8.parse(value.toString()),
    key,
    {
      keySize: 128 / 8,
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );
  return encrypted.toString();
}

export { getUserFavourites, addRemoveFavourites };
